<template>
    <div class="card-footer d-flex justify-content-between align-items-center">
        <span>{{ translate('labels.showing') }} {{ start }} - {{ end }} {{ translate('labels.of') }} {{ total }} {{ translate('labels.entries') }}</span>
        <div class="template-buttons"></div>
        <ul class="pagination pagination-separated pagination-sm align-self-center">
            <li :class="['page-item', 1 === pageModel ? 'disabled' : '']"
                @click="changeCurrencyPage(pageModel - 1)"
            ><button class="page-link legitRipple">←</button></li>

            <li
                v-for="pageNumber in pageMaxNumber"
                :class="['page-item', pageNumber === pageModel ? 'active' : '']"
                @click="changeCurrencyPage(pageNumber)"
            ><button
                v-if="(pageNumber >= pageModel && pageNumber < pageModel + 5) || (pageNumber > pageMaxNumber - 5 && pageModel > pageMaxNumber - 5)"
                class="page-link legitRipple"
            >{{ pageNumber }}</button></li>

            <li :class="['page-item', pageMaxNumber === pageModel ? 'disabled' : '']"
                @click="changeCurrencyPage(pageModel + 1)"
            ><button href="#" class="page-link legitRipple">→</button></li>
        </ul>
    </div>
</template>

<script>
import Button from "./filters/ButtonComponent.vue";
import Select from "./filters/SelectComponent.vue";

export default {
    name: "PaginateComponent",
    components: {Select, Button},
    emits: ['update:page'],
    props: {
        page: {
            type: Number,
            default() {
                return 1;
            }
        },
        limit: {
            type: Number,
            default() {
                return 10;
            }
        },
        total: {
            type: Number,
            default() {
                return 10;
            }
        }
    },
    computed: {
        pageModel: {
            get() {
                return this.page
            },
            set(newValue) {
                this.$emit('update:page', newValue)
            }
        },
        pageMaxNumber() {
            if (this.total <= this.limit || this.limit === 0) {
                return 1;
            }

            return Math.ceil(this.total / this.limit);
        },
        start() {
            if (this.pageModel === 1) {
                return 1;
            }

            return ((this.pageModel - 1) * this.limit) + 1
        },
        end() {
            let end = (this.start + this.limit) - 1;

            return end > this.total ? this.total : end;
        }
    },
    methods: {
        changeCurrencyPage(newValue) {
            if (newValue > this.pageMaxNumber || newValue < 1) {
                return;
            }

            this.pageModel = newValue;
        },
    }
}
</script>

<style scoped>
.paginate {
    display: flex;
    justify-content: space-between;
    padding: 1.25rem;
}

.paginate-text {
    line-height: 32px;
}

.page-item.active .page-link {
    z-index: 1;
    color: #fff;
    background-color: #3f51b5;
    border-color: #3f51b5;
}
</style>
